module.exports = __webpack_public_path__ + "img/trailer-truck-icon.005aacfc.png";